<template>
  <router-view name="slider" v-bind:key="$route.path"></router-view>
</template>
<script>
export default {
  name: "Slider",
};
</script>
